export default __webpack_public_path__ + "static/media/ic_cancel_black.478ee898.svg";